import { useEffect, useState } from 'react';
import http from '../utils/http';

const MARKETS = ['ozon', 'wb', 'ym'];
const REFRESH_MS = 30_000;

function fetchCount(path, filters) {
  return http.get(path, {
    params: {
      ...filters,
      'pagination[page]': 1,
      'pagination[pageSize]': 1,
      'pagination[withCount]': true,
    },
  }).then((response) => response.data?.meta?.pagination?.total ?? 0);
}

export default function useSidebarCounts() {
  const [counts, setCounts] = useState({ ozon: null, wb: null, ym: null, returns: null, requests: null });

  useEffect(() => {
    let active = true;
    let requestId = 0;

    async function refresh() {
      if (document.visibilityState === 'hidden') return;
      const currentRequest = ++requestId;
      const tasks = [
        ...MARKETS.map((market) => fetchCount('/postings', {
          'filters[market][$eq]': market,
          'filters[state][$eq]': 'awaiting_packaging',
        })),
        fetchCount('/return-scans', { 'filters[status][$eq]': 'queued' }),
        fetchCount('/preparation-requests', { 'filters[status][$eq]': 'pending' }),
      ];
      const results = await Promise.allSettled(tasks);
      if (!active || currentRequest !== requestId) return;
      const keys = [...MARKETS, 'returns', 'requests'];
      setCounts((previous) => {
        const next = { ...previous };
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') next[keys[index]] = result.value;
        });
        return next;
      });
    }

    const onVisible = () => {
      if (document.visibilityState === 'visible') void refresh();
    };
    void refresh();
    const interval = window.setInterval(() => void refresh(), REFRESH_MS);
    window.addEventListener('focus', refresh);
    window.addEventListener('marketcrm:sidebar-counts-changed', refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      active = false;
      window.clearInterval(interval);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('marketcrm:sidebar-counts-changed', refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return counts;
}
